export default {
  order: 1,
  layerGroupId: 'GROUP_LCD',
  dataLayer: {
    id: 'TREE_COVER_LOSS',
    order: 1,
    type: 'remoteDataLayer',
    uuid: '2aed67b3-3643-40d3-9c1e-8af9afb5d9e2',
    groupId: 'GROUP_LCD',
  },
  layer: {
    sublabel: {
      ka: '(წლიური, 30მ, გლობალური, Hansen/UMD/Google/USGS/NASA)',
      zh: '(每年更新, 30米, 全球覆盖, 汉森/马里兰大学/谷歌/美国地质测量局(USGS)/美国宇航局(NASA))',
      id: '(annual, 30m, global, Hansen/UMD/Google/USGS/NASA)',
      pt: '(anual, 30m, global, Hansen/UMD/Google/USGS/NASA)',
      es: '(anual, 30m, global, Hansen/UMD/Google/USGS/NASA)',
      fr: '(annuel, 30m, global, Hansen/UMD/Google/USGS/NASA)',
      en: '(annual, 30m, global, Hansen/UMD/Google/USGS/NASA)',
    },
    label: {
      ka: 'ხის ვარჯის კარგვა',
      zh: '森林覆盖损失',
      id: 'Tree cover loss',
      pt: 'Perda de cobertura arbórea',
      es: 'Pérdida de la cobertura arbórea',
      fr: 'Perte en couvert arboré',
      en: 'Tree cover loss',
    },
    technicalName: 'tree_cover_loss',
    maxYear: 17,
    minYear: 1,
    url: 'https://tiles.globalforestwatch.org/umd_tree_cover_loss/v1.12/tcd_30/{z}/{x}/{y}.png',
    type: 'loss',
    id: 'TREE_COVER_LOSS',
    metadata: {
      metadata: null,
      legendConfig: {
        notes: ['Displaying loss with {thresh} canopy density.', 'Tree cover loss is not always deforestation.'],
        source: '(annual, 30m, global, Hansen/UMD/Google/USGS/NASA)',
        threshold: 30,
        dataMaxZoom: 12,
        items: [
          {
            name: {
              en: 'Total loss',
              fr: 'Total loss',
              es: 'Total loss',
              pt: 'Total loss',
              id: 'Total loss',
              zh: 'Total loss',
              ka: 'Total loss',
            },
            color: '#DC6499',
            outlineColor: '#555555',
          },
        ],
        type: 'basic',
        name: {
          ka: 'ხის ვარჯის კარგვა',
          zh: '森林覆盖损失',
          id: 'Tree cover loss',
          pt: 'Perda de cobertura arbórea',
          es: 'Pérdida de la cobertura arbórea',
          fr: 'Perte en couvert arboré',
          en: 'Tree cover loss',
        },
      },
      interactionConfig: {},
    },
  },
  isMetadataError: false,
  isError: false,
};
